import {LegacyPersonAdaptor} from './legacyPersonAdaptor.js';

export var LegacySponsorAdaptor = function(sponsorData) {
    var sponsor = {};
    
    // Constructor
    if (sponsorData) {
        var fullName = sponsorData.names.getAName();

        sponsor.id = sponsorData.id;
        sponsor.firstName = sponsorData.names.getFirstName(fullName);
        sponsor.lastName = sponsorData.names.getLastName(fullName);
        sponsor.profileThumbnailUrl = sponsorData.profileThumbnailUrl;
        sponsor.primaryPerson = LegacyPersonAdaptor(sponsorData.primaryPerson);
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return sponsor;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacySponsorAdaptor.js
// module id = 39
// module chunks = 0